import { ValidationResult } from "./validation-result";
import { Settings } from "../services/settings";
export interface ServiceRequest {
	id: number;
	serviceRequestTypeId: number;
	agencyId: number;
	caseId: number;
	flatRequestId: number | null;
	requestStatusId: number;
	collaborationRequest: number | null;
	amountRequested: number | null;
	totalAmountProvided: number | null;
	recordStatus: number | null;
	autoMatchAttempt: number | null;
	caseNumber: string;
	caseName: string;
	zipCode: string;
	dateCreated: Date;
	dueDate: Date;
	daysLapsed: number;
	daysLeft: number;
	serviceRequestDesc: string;
	requestStatusDesc: string;
	unitOfMeasure: string;
	statusReasonId: number;
	serviceDefId: number;
	dateCompleted: Date;
	currentNeed: string;
	lastModifiedBy: string;
	plannedCommitted: string;
	collabList: string;
	assignAttempts: number;
	dateQualifier: string;
	startDate: string;
	endDate: string;
	keepOpen: number;
	clericalOpen: number;
	
	newDateSubmitted: string;
	newDateCompleted: string;
	suppressEmailFlag: number;
}

export class ServiceRequest {
	constructor() {
		this.id = 0;
		this.serviceRequestTypeId = 0;
		this.agencyId = 0;
		this.serviceDefId = 0;
		this.caseId = 0;
		this.flatRequestId = 0;
		this.requestStatusId = 0;
		this.collaborationRequest = null;
		this.amountRequested = null;
		this.totalAmountProvided = null;
		this.recordStatus = 1;
		this.autoMatchAttempt = 0;
		this.dateCreated = new Date();
		this.lastModifiedBy = Settings.getInstance().loggedInUser.username;
		this.collabList = '';
		this.assignAttempts = 0;
		this.dateQualifier = '';
		this.startDate = null;
		this.endDate = null;
		this.keepOpen = 0;
		this.clericalOpen = 0;
	}
	validateRecord(): ValidationResult {
		const vr: ValidationResult = new ValidationResult();
		return vr;
	}
}
